const updateLocalStorage = (item, value) => {
    const data = JSON.parse(localStorage.getItem(item));
    const newValue = { ...data, ...value };
    localStorage.setItem(item, JSON.stringify(newValue));
};

export default updateLocalStorage;
